/* WEEKLYREPORT */
export const WEEKLYREPORT_LIST = 'WEEKLYREPORT_LIST';
export const WEEKLYREPORT_LIST_SUCCESS = 'WEEKLYREPORT_LIST_SUCCESS';
export const WEEKLYREPORT_LIST_FAILED = 'WEEKLYREPORT_LIST_FAILED';


